export default {
    title: 'Mapas extras',
    subtitle: 'Faça o mapa astral de qualquer pessoa',
    tooltipNew: 'Crie Mapas Extras de pessoas que você conhece!',
    preview: {
        seeMap: 'Ver mapa',
        seeHoroscope: 'Ver horóscopo',
        seeHoroscopeSoon: '<strong>Em breve!</strong>',
        seeSinastry: 'Ver sinastria',
        activeInfluences: 'Influências ativas',
        newMap: 'Novo mapa',
        emptyMessage: 'Você pode criar o mapa astral de qualquer pessoa para consultá-lo a qualquer momento!',
        buttonNewMap: 'Criar mapa extra',
        seeMapLink: 'gerenciar-mapas/{mapId}',
        newMapLink: 'gerenciar-mapas?action=new&referer=explore',
        synastryLink: 'mapas/sinastria/'
    },

    errorMessage: 'Não foi possível carregar os mapas extras'
};
